module.exports = __webpack_public_path__ + "static/11-b21978c0b87116c93fcc3cdf9dcfaf22.jpg";